import { getSectionByKey } from '@/services/siteSections';

// Logo por defecto como fallback (el nuevo logo subido por el admin)
const DEFAULT_LOGO_URL = 'https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/087e082e330e8397f7455cc656f090bf.png';

let cachedLogoUrl: string | null = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

/**
 * Obtiene la URL del logo de la empresa desde la sección hero de site_sections.
 * Usa caché de 5 minutos para evitar consultas repetitivas.
 * Si falla o no hay logo configurado, devuelve el logo por defecto.
 */
export async function getCompanyLogoUrl(): Promise<string> {
  const now = Date.now();
  if (cachedLogoUrl && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedLogoUrl;
  }

  try {
    const heroSection = await getSectionByKey('hero');
    if (heroSection?.content_json?.logo && typeof heroSection.content_json.logo === 'string' && heroSection.content_json.logo.trim() !== '') {
      cachedLogoUrl = heroSection.content_json.logo;
      cacheTimestamp = now;
      return cachedLogoUrl;
    }
  } catch (error) {
    console.error('Error obteniendo logo de site_sections:', error);
  }

  cachedLogoUrl = DEFAULT_LOGO_URL;
  cacheTimestamp = now;
  return DEFAULT_LOGO_URL;
}

/**
 * Invalida la caché del logo (llamar después de actualizar el logo en admin)
 */
export function invalidateLogoCache(): void {
  cachedLogoUrl = null;
  cacheTimestamp = 0;
}